import { cancelSubscription } from "./cancel-subscription"
import { metrics } from "./metrics"

export const admin = {
  metrics,
  cancelSubscription,
}
